// import mui link
import { useAppSelector } from 'src/store';
import 'react-phone-input-2/lib/style.css'
import DocumentMeta from 'react-document-meta';
import { meta } from 'src/libs/utils';
import { getBranding } from 'src/utils/branding';
import { Box } from '@mui/material';
import useAuth from 'src/hooks/useAuth';


const params = new URLSearchParams(window.location.search)
const categoryCookie = document.cookie.replace(/(?:(?:^|.*;\s*)rmk_category\s*\=\s*([^;]*).*$)|^.*$/, "$1");
const category = categoryCookie || params.get("category");
import MultiStepRegistration from '../components/Onboarding/Account/MultiStepRegistration';
import Login from '../components/Onboarding/Account/Login';
import ChannelsPage from './channels';
import { useEffect, useState } from 'react';
import ForgotPassword from '../components/Onboarding/Account/ForgotPassword';
import ResetPassword from '../components/Onboarding/Account/ResetPassword';
import { useNavigate } from 'react-router-dom';
import LavaLampBackground from 'src/components/ThemeElements/LavaLampBackground';
import SignInForm from '../components/Onboarding/Account/SignInForm';
import ActivityFeed from '../components/Onboarding/Account/ActivityFeed';
import TickerSlider from '../components/Onboarding/Account/TickerSlider';
import TickerCarouselSidebar from '../components/Onboarding/Account/TickerCarouselSidebar';
import { useMediaQuery, useTheme } from '@mui/material';

const Auth = ({ screen = "register" }) => {

  const { isLoggedIn, authLoading } = useAuth();
  const { user } = useAppSelector(state => state.user)
  const branding_logo = getBranding('oppy_word_mark_yellow');
  const [displayedAuthScreen, setDisplayedAuthScreen] = useState(screen)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  let navigate = useNavigate();

  // Check for login error from registration flow
  useEffect(() => {
    const loginError = sessionStorage.getItem('loginError');
    if (loginError) {
      // Clear the error from sessionStorage
      sessionStorage.removeItem('loginError');

      // Set the screen to login and show the error
      setDisplayedAuthScreen('login');

      // You can also dispatch an action to show the error in the auth state
      // This will be handled by the login component
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      // redirect to /conversations
      navigate('/conversations')
    }
  }, [isLoggedIn, navigate])

  return (
    <>
      <DocumentMeta {...meta} />
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
        zIndex={-1}
        sx={{
          backgroundColor: 'backgroundDark.default',
        }}
      >
        <LavaLampBackground />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        minHeight="100vh"
        flexDirection="column"
        p={{ xs: 2, sm: 2, md: 4 }}
        sx={{

        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          component="img"
          src={branding_logo}
          sx={{
            mb: displayedAuthScreen === 'register' ? 2 : -1,
            mt: { xs: 1, md: 2 },
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'center',
            height: { xs: 60, sm: 80, md: 120 },
            width: { xs: 105, sm: 140, md: 200 },
          }}
        />
        {displayedAuthScreen === 'register' ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            px={{ xs: 2, sm: 3, md: 0 }}
          >
            {/* Mobile Layout with Bottom Ticker */}
            {isMobile ? (
              <Box
                sx={{
                  width: '100%',
                  maxWidth: '100%',
                  px: 0,
                  pb: 8, // Add padding at bottom for fixed ticker
                }}
              >
                <Box
                  sx={{
                    backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    mx: 2,
                    width: 'calc(100% - 32px)',
                  }}
                >
                  <MultiStepRegistration 
                    onToggleSignIn={() => setDisplayedAuthScreen('login')}
                  />
                </Box>
                
                {/* Fixed Bottom Ticker for Mobile */}
                <Box
                  sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                    borderTop: `1px solid ${theme.palette.divider}`,
                    height: 60,
                    zIndex: 10,
                    overflow: 'hidden',
                  }}
                >
                  <TickerSlider />
                </Box>
              </Box>
            ) : (
              /* Desktop Layout - Two Column Grid */
              <Box
                display="grid"
                gridTemplateColumns="480px 1fr"
                gap={3}
                maxWidth="1100px"
                width="100%"
                alignItems="center"
              >
                {/* Left Column - Form */}
                <Box
                  sx={{
                    backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                    borderRadius: '16px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                    overflow: 'visible',
                  }}
                >
                  <MultiStepRegistration 
                    onToggleSignIn={() => setDisplayedAuthScreen('login')}
                  />
                </Box>
                
                {/* Right Column - Testimonials */}
                <TickerCarouselSidebar />
              </Box>
            )}
          </Box>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            px={{ xs: 2, sm: 3, md: 0 }}
          >
            {!(isLoggedIn && user) ?
              <>
                {displayedAuthScreen === "login" && (
                  /* Mobile Layout with Bottom Ticker */
                  isMobile ? (
                    <Box
                      sx={{
                        width: '100%',
                        maxWidth: '100%',
                        px: 0,
                        pb: 8, // Add padding at bottom for fixed ticker
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                          borderRadius: '12px',
                          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                          mx: 2,
                          width: 'calc(100% - 32px)',
                        }}
                      >
                        <SignInForm 
                          onToggleRegister={() => setDisplayedAuthScreen('register')}
                        />
                      </Box>
                      
                      {/* Fixed Bottom Ticker for Mobile */}
                      <Box
                        sx={{
                          position: 'fixed',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                          borderTop: `1px solid ${theme.palette.divider}`,
                          height: 60,
                          zIndex: 10,
                          overflow: 'hidden',
                        }}
                      >
                        <TickerSlider />
                      </Box>
                    </Box>
                  ) : (
                    /* Desktop Layout - Two Column Grid */
                    <Box
                      display="grid"
                      gridTemplateColumns="440px 1fr"
                      gap={3}
                      maxWidth="1000px"
                      width="100%"
                      alignItems="center"
                    >
                      {/* Left Column - Sign In Form */}
                      <Box
                        sx={{
                          backgroundColor: theme => theme.palette.mode === 'dark' ? 'grey.900' : 'white',
                          borderRadius: '16px',
                          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                          overflow: 'visible',
                        }}
                      >
                        <SignInForm 
                          onToggleRegister={() => setDisplayedAuthScreen('register')}
                        />
                      </Box>
                      
                      {/* Right Column - Testimonials */}
                      <TickerCarouselSidebar />
                    </Box>
                  )
                )}
                {displayedAuthScreen === "forgot_password" &&
                  <ForgotPassword setDisplayedAuthScreen={setDisplayedAuthScreen} displayedAuthScreen={displayedAuthScreen} />
                }
                {displayedAuthScreen === "reset_password" &&
                  <ResetPassword setDisplayedAuthScreen={setDisplayedAuthScreen} displayedAuthScreen={displayedAuthScreen} />
                }
              </>
              :
              <ChannelsPage />
            }
          </Box>
        )}
      </Box>
      {/* Activity Feed - Desktop only at bottom of page */}
      {displayedAuthScreen === 'register' && !isMobile && <ActivityFeed />}
    </>
  );
};

export default Auth;
